function fadeInElementsOnViewport(): void {
  // .js-fadeinと.js-fadein-upの両方を選択
  const fadeInElements = document.querySelectorAll(".js-fadein, .js-fadein-up, .js-reveal-left-to-right");

  const observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.3,
  };

  const observerCallback = (entries: IntersectionObserverEntry[], observer: IntersectionObserver) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-visible");
        if (entry.target) {
          observer.unobserve(entry.target); // 一度フェードインしたら監視を停止
        }
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);

  fadeInElements.forEach((element) => {
    observer.observe(element);
  });
}

export { fadeInElementsOnViewport };
